var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}draft-24`,"viewBox":"0 0 24 24"}},[_c('circle',{staticClass:"base",attrs:{"cx":"12","cy":"12","r":"12"}}),_c('circle',{staticClass:"sign",attrs:{"cx":"12","cy":"12","r":"7","stroke-width":"2","stroke-dasharray":"2.9 2.6"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }